
module.exports =  require('./lib/');



/*****************
 ** WEBPACK FOOTER
 ** ./~/socket.io-client/~/engine.io-client/index.js
 ** module id = 95
 ** module chunks = 0
 **/